var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLayoutShape2 = function SvgLayoutShape2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h8.5zM22 0a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-8.5a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1H22z",
    fillRule: "evenodd"
  })));
};
export default SvgLayoutShape2;